import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'

export type NotificacaoCountContextModel = Record<TipoTopicoNotificacaoEnum, number>

export const defaultCountTipoNotificacaoRecord: NotificacaoCountContextModel = {
  [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: 0,
  [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: 0,
}

export type OperacaoNotificacao = 'ADD' | 'SUB'

export interface NotificacaoDeltaAtmosphereResponse {
  operacao: OperacaoNotificacao
  valor: number
  tipoNotificacao: TipoTopicoNotificacaoEnum
}

export type NotificacaoDeltaAtmosphereResponseList = NotificacaoDeltaAtmosphereResponse[]
